/* eslint-disable max-len */
import React, { useState, useEffect } from "react";
import { StepComponent } from "../../../components/Steps";
import BasicDetails from "../BasicDetails";
import BookingDetails from "../BookingDetails";
import AddressDetails from "../AddressDetails";
import ServiceDetails from "../ServiceDetails";
import {
  getServiceAbilityCheckReset,
  getCalculaterRateChartClear,
  clearBarcodeId,
} from "../../../actionsMethods/cashBookingMethods";
import axios from "axios";
import { useDispatch } from "react-redux";

const AccountBookingSteps = () => {
  const [current, setScreen] = useState(0);
  const [allData, setAllData] = useState({});
  const [formRerender, setFormRerender] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  const senderSms = async () => {
    try {
      let res = await axios.get(
        `https://pgapi.vispl.in/fe/api/v1/send?username=shremotpg.trans&password=uNIvT&unicode=false&from=SMCSPL&dltPrincipalEntityId=1001569800000012636&dltContentId=1007163186467531163&text=Shree Maruti Courier
        Your shipment ${allData?.awbNumber} is booked with Shree Maruti Courier. To track your shipment you can visit https://www.shreemaruticourier.com/tracking/?d=${allData?.awbNumber}&to=${allData?.senderMobileNumber}`
      );
      if (res.data) {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const recieverSms = async () => {
    try {
      let res = await axios.get(
        `http://wa3.nuke.co.in/admin/sendwhatsapp/insert_whatsapp_api1?username=maruticourier&password=*********&mobile_no=${allData?.receiverMobilenumber}&message=message_to_consigner_while_cash_booking_ft_vp_service_v2_2&uploaded1=whatsapp/2023-01-02_09:53:33842368-cash-invoice.pdf&uploaded2=FastTrack&uploaded3=${allData?.awbNumber}&uploaded4=ASF&uploaded5=DELHI&uploaded6=https://www.shreemaruti.com/dw/?a=R98s3K&uploaded7=https://www.shreemaruti.com/dw/?a=S79s3P&uploaded9=tracking/?d=${allData?.awbNumber}`
      );

      if (res.data) {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const reRenderCallback = () => {
    senderSms();
    recieverSms();
    setScreen(0);
    setFormRerender(!formRerender);
    setAllData({});
    dispatch(getServiceAbilityCheckReset());
    dispatch(getCalculaterRateChartClear());
    dispatch(clearBarcodeId());
  };

  const onChange = (value) => {
    setScreen(value);
  };

  useEffect(() => {
    if (current == 0) {
      setAllData({});
    }
  }, [current]);

  function handleScreen(val) {
    return setScreen(val);
  }

  const upDateAllData = (data) => {
    setAllData({ ...allData, ...data });
  };

  const steps = [
    {
      step: 1,
      title: "Basic Details",
      //   icon: book,
      content: (
        <BasicDetails
          screen={handleScreen}
          currentScreen={current}
          upDateAllData={upDateAllData}
          check={formRerender}
        />
      ),
      description: "Please provide your name details",
    },
    {
      step: 2,
      title: "Booking Details",
      //   icon: firm,
      content: (
        <BookingDetails
          screen={handleScreen}
          currentScreen={current}
          upDateAllData={upDateAllData}
          allData={allData}
          check={formRerender}
        />
      ),
      description: "Please provide booking details",
    },
    {
      step: 3,
      title: "Address",
      content: (
        <AddressDetails
          screen={handleScreen}
          currentScreen={current}
          upDateAllData={upDateAllData}
          allData={allData}
          check={formRerender}
        />
      ),
      description: "Please provide address details",
      //   icon: personal,
    },
    {
      step: 4,
      title: "Service Details",
      content: (
        <ServiceDetails
          screen={handleScreen}
          currentScreen={current}
          allData={allData}
          reRenderCallback={reRenderCallback}
        />
      ),
      description: "Please provide service details",
      //   icon: personal,
    },
  ];
  return (
    <div style={{ width: "100%", margin: 0 }}>
      <StepComponent current={current} onChange={onChange} steps={steps} />
    </div>
  );
};

export default AccountBookingSteps;
